const updateSelectedWorkout = (state, { payload: { workout } }) => {
	state.selectedWorkout = workout;
};

export default updateSelectedWorkout;
